<style scoped>
.suggestion {
    font-size: 18px;
    margin-bottom: 20px;
}

.buttons-row {
    --grid-gutter: 10px;
}

.social-media-button {
    width: 48px;
    height: 48px;
    border: 1px solid var(--neutral5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
</style>

<template>
    <div>
        <cp-grid class="buttons-row" justify="center" align="center">
            <cp-grid-item span="2.5">
                <span class="social-media-button" @click="handleProvider('facebook')">
                    <img src="https://assets.staging.crowdblue.com/v2/demo/all/img/facebook-icon.svg" />
                </span>
            </cp-grid-item>

            <cp-grid-item span="2.5">
                <span class="social-media-button" @click="handleProvider('twitter')">
                    <img src="https://assets.staging.crowdblue.com/v2/demo/all/img/twitter-x-icon.svg" />
                </span>
            </cp-grid-item>

            <cp-grid-item span="2.5">
                <span class="social-media-button" @click="handleProvider('google')">
                    <img src="https://assets.staging.crowdblue.com/v2/demo/all/img/google-icon.svg" />
                </span>
            </cp-grid-item>
        </cp-grid>
    </div>
</template>

<script>
import CpButton from '../button';
import CpGrid from '../grid';
import CpGridItem from '../grid-item';
import CpIcon from '../icon';

export default {
    components: {
        CpButton,
        CpGrid,
        CpGridItem,
        CpIcon
    },

    props: {
        handleProvider: {
            type: Function,
            default: function () { },
        },
        provider: null,
    },
};
</script>
